<div class="p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="m-0">Sous-traitants</h3>
    <span class="badge" 
      [class.badge-error]="selectedSousTraitants().length < 2"
      [class.badge-info]="selectedSousTraitants().length === 2"
      [class.badge-warning]="selectedSousTraitants().length >= 3">
      {{ selectedSousTraitants().length }} / 3 sélectionné(s) (min 2)
    </span>
  </div>

  @if (successMessage()) {
  <div class="alert alert-success mb-4">{{ successMessage() }}</div>
  }
  @if (isProjectLocked()) {
  <div class="alert alert-warning mb-4">
    Projet verrouillé (VALIDE/TERMINE): les sous-traitants ne peuvent plus être modifiés.
  </div>
  }
  @if (readonlyMode) {
  <div class="alert alert-warning mb-4">
    Vous n'avez pas les droits pour modifier les sous-traitants du projet.
  </div>
  }
  @if (localErrorMessage()) {
  <div class="alert alert-error mb-4">{{ localErrorMessage() }}</div>
  }

  <div class="form-group mb-4" *ngIf="!readonlyMode">
    <label>AJOUTER UN SOUS-TRAITANT</label>
    <div class="dropdown-select" (click)="$event.stopPropagation()">
      <button type="button" class="select-btn" (click)="toggleSousTraitantDropdown()"
        [disabled]="isSaving() || selectedSousTraitants().length >= 3 || isProjectLocked()">
        {{ selectedSousTraitants().length < 3 ? 'Sélectionner un sous-traitant à ajouter...'
          : 'Limite de 3 sous-traitants atteinte' }} <span class="caret">▾</span>
      </button>
      <div class="dropdown-panel" *ngIf="showSousTraitantDropdown()">
        <input type="text" class="dropdown-search" placeholder="Rechercher par nom, SIRET, ville..."
          (input)="onSousTraitantSearchChange($any($event.target).value)">
        <div class="options-list">
          @for (s of sousTraitantOptions(); track s.id) {
          <div class="option-item" (click)="selectSousTraitant(s)">
            <div class="option-title">{{ s.denomination }}</div>
            <div class="option-sub">{{ s.ville }} • SIRET : {{ s.siret }}</div>
          </div>
          } @empty {
          <div class="empty-option">Aucun sous-traitant trouvé</div>
          }
        </div>
        <button type="button" class="load-more" (click)="loadMoreSousTraitants()"
          [disabled]="sousTraitantPage() + 1 >= sousTraitantTotalPages() || isLoadingSousTraitants()">
          {{ isLoadingSousTraitants() ? 'Chargement...' : (sousTraitantPage() + 1 < sousTraitantTotalPages()
            ? 'Charger plus' : 'Fin de liste' ) }} </button>
      </div>
    </div>
  </div>

  <div class="st-list-container">
    <label class="mb-2 d-block">SOUS-TRAITANTS LIÉS AU PROJET</label>
    <div class="st-grid">
      @for (st of selectedSousTraitants(); track st.id) {
      <div class="st-card">
        <div class="st-card-header">
          <div class="st-name">{{ st.denomination }}</div>
          <button type="button" class="btn-remove-st" (click)="removeSousTraitant(st.id!)"
            [disabled]="isSaving() || isProjectLocked()" *ngIf="!readonlyMode" title="Retirer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="st-card-body">
          <div class="st-info-item">
            <span class="label">Numéro:</span>
            <span class="value">{{ st.codeComptable || '-' }}</span>
          </div>
          <div class="st-info-item">
            <span class="label">SIRET:</span>
            <span class="value">{{ st.siret || '-' }}</span>
          </div>
          <div class="st-info-item">
            <span class="label">Qualification:</span>
            <span class="value qualification-tag">{{ st.qualification || 'Non spécifiée' }}</span>
          </div>
        </div>
      </div>
      } @empty {
      <div class="empty-list-message">
        <mat-icon>info_outline</mat-icon>
        <p>Afin de pouvoir valider le projet, vous devez sélectionner au minimum 2 sous-traitants.</p>
      </div>
      }
    </div>
  </div>

  @if (showConfirmDelete()) {
  <app-confirm-dialog title="Retirer le sous-traitant"
    message="Êtes-vous sûr de vouloir retirer ce sous-traitant de ce projet ?" (confirmed)="confirmRemoveSousTraitant()"
    (cancelled)="cancelRemoveSousTraitant()">
  </app-confirm-dialog>
  }
</div>